/** If two coordinates are within 500m, they are considered as potentially the same site. */
export const coordinateDistanceThreshold = 500;

/**
 * The maximum request body size in bytes, equivalent to 5000 kB.
 * This is used in body-parser's [limit option](https://github.com/expressjs/body-parser?tab=readme-ov-file#limit-3).
 */
export const requestLimit = 5120000;

/** The rate limit per minute for requests to the Google Maps Geocoding API. */
export const geocodingRequestsPerMinuteLimit = 3000;

/** The maximum file size, in bytes, allowed for a Document Exchange upload (150 MB). */
export const maxDocumentUploadSize = 157286400;
